import { Avatar, Box, Typography } from "@mui/material";
import InfoPopper from "../popper/InfoPopper";

interface Props {
  title: string;
  info?: string;
  text1: string;
  text2?: string;
  icon?: string;
  text1Icon?: JSX.Element;
}

const OverviewCardDetail = (props: Props) => {
  return (
    <Box display={"flex"} flexDirection={"row"} gap={"8px"}>
      <Box display={"flex"} flexDirection={"column"} gap={"4px"} flex={1}>
        <Box display={"flex"} flexDirection={"row"}>
          <Typography
            variant="body1"
            sx={{
              display: "-webkit-box",
              overflow: "hidden",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 1,
            }}
          >
            {props.title}
          </Typography>
          {props.info && <InfoPopper text={props.info} />}
        </Box>

        <Box display={"flex"} flexDirection={"row"}>
          <Typography display={"flex"} flex={1} variant="h2">
            {props.text1}
          </Typography>

          {props.text1Icon}
        </Box>
        {props.text2 && <Typography variant="body1">{props.text2}</Typography>}
      </Box>
      {props.icon && (
        <Avatar src={props.icon} sx={{ width: "33px", height: "33px" }} />
      )}
    </Box>
  );
};

export default OverviewCardDetail;
